import React from 'react';
import { WARRANTY_STARTS_FROM, WARRANTY_YEARS, WARRANTY_COVER } from '../../config/warranty';

// Footnote at the bottom of HomePage explaining the warranty terms
// for the asterisked claims throughout the page.
export default function WarrantyDisclaimer() {
  return (
    <div className="asg-warranty-disclaimer">
      <p>*On awnings, the warranty covers {WARRANTY_COVER.awning.covers}; on pergolas, {WARRANTY_COVER.pergola.covers}. Both for {WARRANTY_YEARS} years from the {WARRANTY_STARTS_FROM}. Excludes damage caused by misuse, unauthorised modifications, extreme weather events beyond design loads, or normal wear of moving components such as louvre motors and retractable mechanisms. The Dooya motor and other electrical components and accessories are covered by their respective manufacturer warranties, separate from this warranty. Full warranty terms are provided at the time of purchase. <a href="/terms">View full terms &amp; conditions.</a></p>
    </div>
  );
}
